import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AccountService } from '@app/core/services/account.service';

@Component({
  selector: 'app-account-access-notice',
  imports: [RouterLink],
  template: `
    @if (accounts.access(); as access) {
      @if (access.can_read && !access.can_write) {
        <aside aria-label="Account access" class="border-b border-bad/15 bg-bad/10 px-4 py-3 sm:px-8">
          <div class="mx-auto flex max-w-[84rem] flex-wrap items-center justify-center gap-x-4 gap-y-2 text-center text-sm text-ink">
            <p class="flex min-w-0 items-start gap-2">
              <span class="iconify tabler--lock mt-0.5 shrink-0 text-base" aria-hidden="true"></span>
              <span>
                <span class="font-medium text-bad">{{ access.reason === 'trial_expired' ? 'Trial ended.' : 'Read-only access.' }}</span>
                Your setup and retained logs are still available.
              </span>
            </p>
            @if (accounts.hasRole('admin')) {
              <a routerLink="/settings/plans" class="inline-flex shrink-0 items-center gap-1 rounded-sm2 font-medium text-bad underline decoration-bad/50 underline-offset-4 hover:decoration-bad focus-visible:outline focus-visible:outline-2 focus-visible:outline-bad">
                View plans <span class="iconify tabler--arrow-right text-sm" aria-hidden="true"></span>
              </a>
            } @else {
              <span>Ask your account owner to choose a plan.</span>
            }
          </div>
        </aside>
      }
    }
  `,
})
export class AccountAccessNoticeComponent {
  readonly accounts = inject(AccountService);
}
